import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UserDataResponse } from '../interfaces/login-data-response.interface';

export type AuthEventType = 'login' | 'logout' | 'user-loaded';

export interface AuthEvent {
  type: AuthEventType;
  userData: UserDataResponse | null;
}

@Injectable({ providedIn: 'root' })
export class AuthEventService {
  private eventSubject = new Subject<AuthEvent>();
  public events$ = this.eventSubject.asObservable();

  public emitEvent(event: AuthEvent): void {
    this.eventSubject.next(event);
  }

  // Convenience-Methoden
  public emitLogin(userData: UserDataResponse): void {
    this.emitEvent({ type: 'login', userData });
  }

  public emitUserLoaded(userData: UserDataResponse): void {
    this.emitEvent({ type: 'user-loaded', userData });
  }

  public emitLogout(): void {
    this.emitEvent({ type: 'logout', userData: null });
  }
}